export default __webpack_public_path__ + "static/media/viewtofront2.f830aa4d.jpg";